import React, { Component } from 'react';
import { Route, Routes } from 'react-router';
import AppBody from './components/AppBody';
import Home from './components/Home';
import Roles from './components/admin/Roles';
import CreateRole from './components/admin/CreateRole';
import './custom.css'

import Users from './components/admin/Users';
import Clients from './components/admin/Clients';
import RoleDetails from './components/admin/RoleDetails';
import UserDetails from './components/admin/UserDetails';
import CreateClient from './components/admin/CreateClient';
import ClientDetails from './components/admin/ClientDetails';
import Admin from './components/admin/Admin';
import AccessDenied from './components/util/AccessDenied';
import Login from './components/auth/Login';
import ForgotPassword from './components/ForgotPassword';
import {Logout} from './components/api-authorization/Logout';
import { LogoutActions, ApplicationPaths  } from './components/api-authorization/ApiAuthorizationConstants';
import Equipment from './components/admin/Equipment';
import { ResetPassword } from './components/ResetPassword';
import VehicleAssignments from './components/admin/VehicleAssignments';
import JobListing from './components/admin/JobListing';
import ScheduleJobs from './components/admin/ScheduleJobs';
import DailySchedule from './components/DailySchedule';
import TimeEntry from './components/TimeEntry';
import Audit from './components/admin/Audit';
import TimeReview from './components/TimeReview';

const App = () => {
    return (
        <AppBody>
            <Routes>
                <Route path="/" element={<Home />} />
                <Route path="/admin" element={<Admin />} />
                <Route path="/admin/roles" element={<Roles />} />
                <Route path="/admin/roles/create" element={<CreateRole />} />
                <Route path="/admin/roles/details" element={<RoleDetails />} />
                <Route path="/admin/users" element={<Users />} />
                <Route path="/admin/users/details" element={<UserDetails />} />
                <Route path="/admin/equipment" element={<Equipment/>} />
                <Route path="/admin/vehicle/assignments" element={<VehicleAssignments/>} />
                <Route path="/admin/job-listings" element={<JobListing/>} />
                <Route path="/admin/schedule-jobs" element={<ScheduleJobs/>} />
                <Route path="/admin/clients" element={<Clients />} />
                <Route path="/admin/clients/create" element={<CreateClient />} />
                <Route path="/admin/clients/details" element={<ClientDetails />} />
                <Route path="/accessdenied" element={<AccessDenied />} />
                <Route path="/login" element={<Login />} />
                <Route path="/daily-schedule" element={<DailySchedule />} />
                <Route path="/time-entry" element={<TimeEntry />} />
                <Route path='/time-review' element={<TimeReview />}/>
                <Route path="/admin/audit" element={<Audit />} />

                {/* <Route path='/forgot' element={<ForgotPassword/>}/>
                <Route path='/reset' element={<ResetPassword/>}/> */}

                {/* <Route path="/logout" element={<Logout action={LogoutActions.Logout}/>} />
                 */}
                 <Route path="/logout" 
                    element={<Logout action={LogoutActions.Logout} />} />

                <Route path="/authentication/logout-callback"
                    element={<Logout action={LogoutActions.LogoutCallback} />} />

                <Route path="/authentication/logged-out"
                    element={<Logout action={LogoutActions.LoggedOut} />} />

            </Routes>
        </AppBody>

    );
}

export default App;
